import { useKernelApi } from 'infrastructure/api';
import { useDateTimeService } from 'framework/utils';

export const READ_SECURITY_AUDIT_LOG = 'READ_SECURITY_AUDIT_LOG';

const useAuditService = () => {
  const { sendGetRequest } = useKernelApi();
  const { formatDateTimeForAPI } = useDateTimeService();

  const getRoleAssignmentsReport = async ({ filters }: Dictionary<any>) => {
    try {
      const period = filters.dateTime.eq;
      return await sendGetRequest(`/audit/roles/report?dateBeforeAt=${formatDateTimeForAPI(period)}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in getRoleAssignmentsReport:', error);
      return { json: () => Promise.resolve([]) };
    }
  };

  const getPermissionsConfigurationReport = async ({ filters }: Dictionary<any>) => {
    try {
      const period = filters.dateTime.eq;
      return await sendGetRequest(`/audit/permissions/report?dateBeforeAt=${formatDateTimeForAPI(period)}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in getPermissionsConfigurationReport:', error);
      return { json: () => Promise.resolve([]) };
    }
  };

  const getArtifactsConfigurationReport = async ({ filters }: Dictionary<any>) => {
    try {
      const from = filters.dateOfAccess?.ge;
      const to = filters.dateOfAccess?.le;
      const params: any = {};

      if (from) {
        params.dateFrom = from;
      }
      if (to) {
        params.dateTo = to;
      }
      const searchParams = new URLSearchParams(params);
      return await sendGetRequest(`/artifacts/security/audit?${searchParams.toString()}`);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error in getArtifactsConfigurationReport:', error);
      return { json: () => Promise.resolve([]) };
    }
  };

  return {
    getRoleAssignmentsReport,
    getPermissionsConfigurationReport,
    getArtifactsConfigurationReport,
  };
};

export default useAuditService;
